export default class FloatingImages {
  constructor() {
    this.floatingImages = document.querySelectorAll(".floating_image");
    this.mouseX = 0;
    this.mouseY = 0;
    this.targetX = 0;
    this.targetY = 0;
    this.currentX = 0;
    this.currentY = 0;
    this.isMouseMoving = false;
    this.animationId = null;
    this.easing = 0.1; // Facteur d'easing (plus bas = plus smooth)

    if (this.floatingImages.length > 0) {
      this.init();
    }
  }

  init() {
    // Écouter les mouvements de la souris
    document.addEventListener("mousemove", (e) => {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
      this.isMouseMoving = true;
      this.startAnimation();
    });

    // Arrêter l'animation quand la souris quitte la page
    document.addEventListener("mouseleave", () => {
      this.isMouseMoving = false;
      this.targetX = 0;
      this.targetY = 0;
    });

    // Reprendre l'animation quand la souris revient
    document.addEventListener("mouseenter", () => {
      this.isMouseMoving = true;
    });
  }

  startAnimation() {
    if (this.animationId) return;
    
    const animate = () => {
      this.updateParallax();
      
      if (this.isMouseMoving || Math.abs(this.currentX) > 0.1 || Math.abs(this.currentY) > 0.1) {
        this.animationId = requestAnimationFrame(animate);
      } else {
        this.animationId = null;
        this.resetParallax();
      }
    };
    
    this.animationId = requestAnimationFrame(animate);
  }

  updateParallax() {
    this.floatingImages.forEach((image) => {
      const rect = image.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      // Calculer la distance entre la souris et le centre de l'image
      const deltaX = (this.mouseX - centerX) / window.innerWidth;
      const deltaY = (this.mouseY - centerY) / window.innerHeight;

      // Facteurs de parallax différents selon la position de l'image
      let parallaxFactor = 0.3; // Facteur par défaut
      let maxDistance = 15; // Distance maximale par défaut

      // Appliquer des facteurs différents selon la classe de l'image
      if (image.classList.contains('top_left_image')) {
        parallaxFactor = 0.4;
        maxDistance = 18;
      } else if (image.classList.contains('top_right_image')) {
        parallaxFactor = 0.6;
        maxDistance = 22;
      } else if (image.classList.contains('bottom_right_image')) {
        parallaxFactor = 0.5;
        maxDistance = 20;
      } else if (image.classList.contains('bottom_left_image')) {
        parallaxFactor = 0.35;
        maxDistance = 16;
      }

      // Calculer la position cible
      const targetX = deltaX * parallaxFactor * maxDistance;
      const targetY = deltaY * parallaxFactor * maxDistance;

      // Interpolation fluide vers la position cible
      const currentX = parseFloat(image.style.getPropertyValue('--parallax-x') || '0px');
      const currentY = parseFloat(image.style.getPropertyValue('--parallax-y') || '0px');

      // Easing vers la position cible
      const newX = currentX + (targetX - currentX) * this.easing;
      const newY = currentY + (targetY - currentY) * this.easing;

      // Appliquer la nouvelle position
      image.style.setProperty('--parallax-x', `${newX}px`);
      image.style.setProperty('--parallax-y', `${newY}px`);
    });
  }

  resetParallax() {
    this.floatingImages.forEach((image) => {
      // Remettre les CSS custom properties à zéro avec easing
      const currentX = parseFloat(image.style.getPropertyValue('--parallax-x') || '0px');
      const currentY = parseFloat(image.style.getPropertyValue('--parallax-y') || '0px');
      
      const newX = currentX * (1 - this.easing);
      const newY = currentY * (1 - this.easing);
      
      image.style.setProperty('--parallax-x', `${newX}px`);
      image.style.setProperty('--parallax-y', `${newY}px`);
    });
  }
}
